import {axiosReq} from "../../../common/utils/axios";

export const tryPostAdvisorSpoofCertificationPurchase = (details) => {
    return async dispatch => {
        console.log(details)
        return axiosReq('apiv1/coach/certifcation/purchase/licensed-plan', "POST", details, {});
    }
};